"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMidiMessage = exports.makeMessage = exports.isChannelMode = void 0;
const isChannelMode = (channel) => channel >= 120;
exports.isChannelMode = isChannelMode;
const makeMessage = ({ channel, command, data1, data2, }) => {
    return Uint8Array.from([command + (channel - 1), data1, data2]);
};
exports.makeMessage = makeMessage;
const toMidiMessage = ([status, data1, data2,]) => {
    const command = (status >> 4) << 4; // cleaning lower bits
    const channel = status - command + 1;
    return {
        channel,
        command,
        data1,
        data2,
    };
};
exports.toMidiMessage = toMidiMessage;
